
import { Component, namespace, Prop } from 'nuxt-property-decorator'
import GoogleRating from '~/components/widgets/GoogleRating.vue'
import PhoneNumberLink from '~/components/snippets/PhoneNumberLink.vue'
import { namespace as baseInfoStore, GetterType as BaseInfoGetterType, BaseInfoState } from '~/store/modules/BaseInfo'
import { SiteNavigationMixin } from '~/mixins/site-navigation.mixin'
import { getExternalIndexHref } from '~/utils/external-links.utils'
import IconWA from '~/assets/icons/icon-wa.svg?inline'

const BaseInfoStore = namespace(baseInfoStore)

@Component({
  components: {
    GoogleRating,
    PhoneNumberLink,
    IconWA,
  },
})
export default class AppFooter extends SiteNavigationMixin {
  @Prop({ required: false, default: false, type: Boolean })
  withFloatingContent!: boolean

  readonly currentYear = new Date().getFullYear()
  readonly waContactNumber = this.$config.WA_WIDGET_NUMBER

  @BaseInfoStore.Getter(BaseInfoGetterType.ACTIVE_PROVIDERS)
  partnersList!: BaseInfoState['providers']

  get externalIndexHref (): string {
    return getExternalIndexHref(this.$config.BASE_URL, this.localePath)
  }
}
